/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { GROUP_TYPES } from 'containers/WGCWXShop/constants'

export const NOT_ENOUGH_PFP = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.not_enough_pfp'
        defaultMessage='На вашем счету недостаточно Очков славы'
    />
)

export const PURCHASE_PRODUCT = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.purchase_product'
        defaultMessage='Купить'
    />
)

export const PURCHASE_PRODUCT_CONFIRMATION = (product, group) => (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.purchase_product.confirmation'
        defaultMessage='Получить бонус «{product}{group}»?'
        values={{ product, group }}
    />
)

export const PREMIUM_BONUSES_NOTICE = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.premium_bonuses_notice'
        defaultMessage='Призовые бонусы будут начислены на ваш аккаунт после завершения этапа награждения.'
    />
)

export const ALL_BONUSES_PURCHASED = {
    [GROUP_TYPES.root]: (
        <FormattedMessage
            id='wgcwx_shop.detailed_product.all_bonuses_purchased'
            defaultMessage='Вы получили все персональные бонусы в данной категории.'
        />
    ),
    [GROUP_TYPES.nation]: (
        <FormattedMessage
            id='wgcwx_shop.detailed_product.all_nation_bonuses_purchased'
            defaultMessage='Вы получили все персональные бонусы выбранной нации.'
        />
    ),
}

export const PURCHASE_IS_NOT_AVAILABLE_YET = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.purchase_is_not_available_yet'
        defaultMessage='Получение призов станет доступно через некоторое время после завершения события.'
    />
)

export const NOT_ENOUGH_PFP_FOR_TANK_WARNING = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.not_enough_pfp_for_tank_warning'
        defaultMessage='В результате данной операции на вашем счету останется меньше Очков славы, чем требуется для получения призовой машины.'
    />
)

export const PRODUCT_CONTENT = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.content'
        defaultMessage='Состав набора'
    />
)

export const NATIONS_TITLE = (
    <FormattedMessage
        id='wgcwx_shop.detailed_product.nations_title'
        defaultMessage='Выбор нации'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/translations.jsx